(() => {
  const init = (root) => {
    if (!root || root.dataset.awSpacerInitialized === 'true') return;
    root.dataset.awSpacerInitialized = 'true';

    const form = root.closest('form[data-product-form]');
    const selector = form && form.querySelector('variant-selection');
    const dataNode = root.querySelector('[data-aw-spacer-variants]');
    let variants = [];

    try {
      variants = JSON.parse(dataNode ? dataNode.textContent : '[]');
    } catch (_error) {
      return;
    }

    const byId = new Map(variants.map((variant) => [String(variant.id), variant]));
    const vehicleNode = root.querySelector('[data-aw-spacer-summary-vehicle]');
    const thicknessNode = root.querySelector('[data-aw-spacer-summary-thickness]');
    const pcdNode = root.querySelector('[data-aw-spacer-summary-pcd]');
    const noticeNode = root.querySelector('[data-aw-spacer-notice]');
    const noticeTitle = root.querySelector('[data-aw-spacer-notice-title]');
    const noticeMessage = root.querySelector('[data-aw-spacer-notice-message]');
    const pricingNode = form && form.closest('.product-main')?.querySelector('[data-product-pricing]');
    let activeVariant = null;

    if (!vehicleNode || !thicknessNode || !pcdNode || !noticeNode || !noticeTitle || !noticeMessage) return;

    const formatMoney = (cents) => {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);
    };

    const renderPricing = (variant) => {
      if (!form || !variant || !variant.native) return;
      const pricing = pricingNode;
      if (!pricing) return;

      const price = Number(variant.native.price || 0);
      const compareAt = Number(variant.native.compare_at_price || 0);
      const priceContainer = pricing.querySelector('[data-price-container]');
      const compareContainer = pricing.querySelector('[data-price-compare-container]');
      const salesBadge = pricing.querySelector('[data-badge-sales]');

      if (priceContainer && (
        priceContainer.querySelector('[data-price-min], [data-price-max]')
        || priceContainer.textContent.trim() !== formatMoney(price)
      )) {
        priceContainer.innerHTML = `<span class="money" data-price>${formatMoney(price)}</span>`;
      }

      if (compareContainer) {
        compareContainer.classList.toggle('visible', compareAt > price);
        const expectedCompare = compareAt > price ? formatMoney(compareAt) : '';
        const currentCompare = compareContainer.querySelector('[data-price-compare]')?.textContent.trim() || '';
        if (currentCompare !== expectedCompare || compareContainer.querySelector('[data-price-compare-min], [data-price-compare-max]')) {
          compareContainer.innerHTML = compareAt > price
            ? `<span class="visually-hidden">Original price</span><span class="money price__compare-at--single" data-price-compare>${expectedCompare}</span>`
            : '';
        }
      }

      if (salesBadge) {
        const onSale = compareAt > price;
        salesBadge.style.display = onSale ? '' : 'none';
        const badgeText = onSale ? `Save ${Math.round(((compareAt - price) / compareAt) * 100)}%` : '';
        if (salesBadge.textContent.trim() !== badgeText) salesBadge.textContent = badgeText;
      }
    };

    const render = (variantId) => {
      const variant = byId.get(String(variantId));
      if (!variant) return;
      activeVariant = variant;

      vehicleNode.textContent = variant.vehicle || '';
      thicknessNode.textContent = variant.thickness || '';
      pcdNode.textContent = variant.pcd || '';
      renderPricing(variant);

      const notice = variant.notice;
      if (!notice || !notice.message) {
        noticeNode.hidden = true;
        noticeTitle.textContent = '';
        noticeMessage.textContent = '';
        return;
      }

      noticeTitle.textContent = notice.title || 'Important fitment notice';
      noticeMessage.textContent = notice.message;
      noticeNode.hidden = false;
    };

    const renderFromForm = () => {
      const variantInput = form && form.querySelector('[name="id"]');
      if (variantInput && variantInput.value) render(variantInput.value);
    };

    const renderFromOptions = () => {
      if (!form) return;

      const vehicleControl = form.querySelector('input[name="Vehicle"]:checked, select[name="Vehicle"]');
      const thicknessControl = form.querySelector('input[name="Thickness"]:checked, select[name="Thickness"]');
      if (!vehicleControl || !thicknessControl) return;

      const variant = variants.find((item) => (
        item.vehicle === vehicleControl.value && item.thickness === thicknessControl.value
      ));
      if (!variant) return;

      form.querySelectorAll('[data-variant-option]').forEach((optionGroup) => {
        const checked = optionGroup.querySelector('input[type="radio"]:checked');
        if (!checked) return;

        optionGroup.dataset.variantOptionChosenValue = checked.value;
        optionGroup.querySelectorAll('[data-variant-option-value-wrapper]').forEach((wrapper) => {
          const input = wrapper.querySelector('input[type="radio"]');
          wrapper.classList.toggle('options-selection__option-value--selected', input === checked);
        });

        const header = optionGroup.closest('fieldset')?.querySelector('[data-variant-option-name]');
        if (header) {
          let optionName = checked.name;
          try {
            optionName = decodeURIComponent(checked.name.replace(/\+/g, ' '));
          } catch (_error) {
            // The raw name is still readable if an app supplies invalid encoding.
          }
          header.textContent = `${optionName}: `;
          const value = document.createElement('span');
          value.textContent = checked.value;
          header.appendChild(value);
        }
      });

      let variantInput = form.querySelector('[name="id"]');
      if (!variantInput) {
        variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        variantInput.setAttribute('data-aw-spacer-variant-id', '');
        form.appendChild(variantInput);
      }
      variantInput.value = String(variant.id);
      render(variant.id);

      // Draft product previews cannot fetch /products/{handle}.js, which
      // prevents Empire from resolving a variant. Emit the same event with
      // Liquid's variant JSON so price, preorder and gallery listeners still
      // receive a complete variant object. On a published product this is a
      // harmless duplicate of Empire's native event.
      if (selector && variant.native) {
        selector.dispatchEvent(new CustomEvent('variant-change', {
          detail: { product: null, variant: variant.native, state: 'selected' },
        }));
      }
    };

    if (selector) {
      selector.addEventListener('variant-change', (event) => {
        if (event.detail && event.detail.variant) render(event.detail.variant.id);
      });

      // Empire reflects the resolved variant ID onto the custom element. This
      // is the most reliable signal when apps or overlays alter click timing.
      new MutationObserver(() => {
        if (selector.getAttribute('variant')) render(selector.getAttribute('variant'));
      }).observe(selector, { attributes: true, attributeFilter: ['variant'] });
    }

    if (form) {
      form.addEventListener('change', () => {
        window.setTimeout(renderFromOptions, 0);
        [60, 240].forEach((delay) => window.setTimeout(renderFromForm, delay));
      });
    }

    if (pricingNode) {
      let pricingRepairQueued = false;
      new MutationObserver(() => {
        if (!activeVariant || pricingRepairQueued) return;
        pricingRepairQueued = true;
        window.setTimeout(() => {
          pricingRepairQueued = false;
          renderPricing(activeVariant);
        }, 0);
      }).observe(pricingNode, { childList: true, subtree: true });
    }

    renderFromForm();
    [0, 180].forEach((delay) => window.setTimeout(renderFromOptions, delay));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-aw-spacer-context]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
